import { useQuery } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

import {
  ICasIdRequirementType,
  IStudentIdRequirementType,
} from './useUpdateRegistration';

interface RegistrationDetails {
  interviewUid: string;
  casIdRequirement: ICasIdRequirementType;
  studentIdRequirement: IStudentIdRequirementType;
}

const useGetRegistrationDetails = (interviewUid: string) => {
  const { data, isLoading, error } = useQuery<RegistrationDetails, Error>(
    ['getRegistrationDetails', interviewUid],
    async () =>
      fetchWithCsrfToken<RegistrationDetails>(
        `${PrependUrl.ASYNC}/registration/get_details`,
        'POST',
        { interview: interviewUid }
      ),
    {
      enabled: !!interviewUid,
    }
  );

  return {
    data,
    isLoading,
    error,
  };
};

export default useGetRegistrationDetails;
